import { PlaybackState } from "../av/types"
import { PlayProgressTracker } from "../play-progress-tracking"

/**
 * A global play progress tracker for our audio player, of which there is only
 * one.
 */
export const playProgressTracker = new PlayProgressTracker({
  playbackRate: 1,
  playbackState: PlaybackState.Idle,
})
